import React from 'react'
import { addProductVariation } from 'client/utils/api-routes-inventory'

import { OrdersContext } from 'contexts/OrdersContext'
import { DcButton, DcDropDown, PixelFactoryContext, DcInput } from 'pixel-base'
import styled from 'styled-components'
import { IPixelFactory } from '../../../../../../decl.d'

const Variants = (props) => {
  const { item, product_id, product, handleClose } = props
  const { showPageLoader, hidePageLoader, showSuccess, showFailure } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const { state } = React.useContext(OrdersContext)

  const [warehouseList, setWarehouseList] = React.useState([])
  const [variant, setVariant] = React.useState<any>({
    variation_type: null,
    variation_value: '',
    sku: 'new',
    price: null,
    cost_price: null,
    stock: '',
    weight: null,
    warehouse_id: null,
  })

  const [error, setError] = React.useState({
    error: '',
    field: '',
  })
  React.useEffect(() => {
    setVariant({
      ...variant,
      sku:
        `${product?.product_base_sku || product?.sku}` +
        `${
          variant?.variation_value !== undefined &&
          variant?.variation_value &&
          `-${variant?.variation_value}`
        }`,
    })
  }, [product, variant?.variation_value])
  React.useEffect(() => {
    setWarehouseList(state?.warehouses)
  }, [state?.warehouses])
  React.useEffect(() => {
    if (item) {
      setVariant(item)
    }
  }, [item])
  const addProductVariations = () => {
    const dataa = {
      variation_type: variant?.variation_type,
      variation_value: variant?.variation_value,
      sku: variant?.sku,
      price: variant?.price,
      cost_price: variant?.cost_price,
      weight: variant?.weight,
    }
    const data = product.manage_inventory ? variant : dataa
    showPageLoader()
    addProductVariation(data, product_id).subscribe((res: any) => {
      hidePageLoader()
      if (res.response.data) {
        showSuccess('Variation Added Successfully')
        handleClose(res.response.data)
      } else {
        if (res.response.error && res.response.field) {
          setError({
            error: res.response.error,
            field: res.response.field,
          })
        } else {
          showFailure(res.response.error || res.response.errors)
        }
      }
    })
  }

  return (
    <VariationContainer>
      <FormGroup>
        {' '}
        <DcDropDown
          error={
            error.field === 'warehouse_id' && error.error !== ''
              ? error.error
              : null
          }
          options={[
            { label: 'Select Variation', value: null },
            { label: 'Color', value: 'color' },
            { label: 'Size', value: 'size' },
            { label: 'Weight', value: 'weight' },
          ]}
          placeholder={'Select Variation'}
          value={variant?.variation_type}
          onChange={(e) => {
            setVariant({
              ...variant,
              variation_type: e.target.value,
            })
          }}
        />{' '}
        <DcInput
          error={
            error.field === 'barcode' && error.error !== '' ? error.error : null
          }
          type={'text'}
          name={'Variation Option'}
          placeholder={
            variant?.variation_type === 'color'
              ? 'Variant Color'
              : variant?.variation_type === 'weight'
              ? 'Variant Weight'
              : variant?.variation_type === 'size'
              ? 'Variant Size'
              : 'Variant Value'
          }
          value={variant?.variation_value}
          onChange={(e) =>
            setVariant({
              ...variant,
              variation_value: e.target.value,
            })
          }
        />{' '}
      </FormGroup>{' '}
      <FormGroup>
        {' '}
        <DcInput
          error={
            error.field === 'price' && error.error !== '' ? error.error : null
          }
          type={'number'}
          name={'Price'}
          placeholder={'Price'}
          value={variant?.price}
          onChange={(e) =>
            setVariant({
              ...variant,
              price: e.target.value,
            })
          }
        />
        <DcInput
          error={
            error.field === 'cost_price' && error.error !== ''
              ? error.error
              : null
          }
          type={'number'}
          name={'Cost Price'}
          placeholder={'Cost Price'}
          value={variant?.cost_price}
          onChange={(e) =>
            setVariant({
              ...variant,
              cost_price: e.target.value,
            })
          }
        />
      </FormGroup>
      <FormGroup>
        {' '}
        <DcInput
          error={
            error.field === 'sku' && error.error !== '' ? error.error : null
          }
          type={'text'}
          name={'SKU'}
          placeholder={'SKU'}
          value={variant?.sku}
          onChange={(e) =>
            setVariant({
              ...variant,
              sku: e.target.value,
            })
          }
        />
        <DcInput
          error={
            error.field === 'weight' && error.error !== '' ? error.error : null
          }
          type={'text'}
          name={'Weight'}
          placeholder={'Weight'}
          value={variant?.weight}
          onChange={(e) =>
            setVariant({
              ...variant,
              weight: e.target.value,
            })
          }
        />
      </FormGroup>
      {!product.manage_inventory && (
        <div style={{ color: 'red' }}>
          {'stock management is turned off you can not set the stock'}
        </div>
      )}
      <FormGroup>
        <DcInput
          disabled={!product.manage_inventory}
          error={
            error.field === 'stock' && error.error !== '' ? error.error : null
          }
          min={0}
          type={'number'}
          name={'Stock'}
          placeholder={'Stock'}
          value={variant?.stock}
          onChange={(e) =>
            setVariant({
              ...variant,
              stock: Number(e.target.value),
            })
          }
        />
        <DcDropDown
          disabled={!product.manage_inventory}
          options={[
            { name: 'Select warehouse', wh_id: null },
            ...warehouseList,
          ].map((data) => {
            return { label: data.name, value: data.wh_id }
          })}
          placeholder={'Select warehouse'}
          value={variant?.warehouse_id}
          onChange={(e) => {
            setVariant({
              ...variant,
              warehouse_id: e.target.value,
            })
          }}
        />
      </FormGroup>
      <FormGroup>
        <DcButton
          size="sm"
          onClick={() => {
            addProductVariations()
          }}
        >
          {item ? 'Update' : 'Add'}
        </DcButton>
      </FormGroup>
    </VariationContainer>
  )
}

export default Variants
const VariationContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  gap: 5px;
`

const FormGroup = styled.div`
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-end;
  align-items: flex-end;
  align-content: flex-end;
  width: 100%;
  flex-grow: 1;
  gap: 10px;
  .full-width {
    flex-grow: 1;
  }
  margin-bottom: 10px;
`
